import { IStatusListUpdate } from './@types';

export const setProductToUpdate = (state: IStatusListUpdate, payload: any) => {
  return {
    ...state,
    productToUpdateStatus: payload,
  };
};

export const setCategoryToUpdate = (state: IStatusListUpdate, payload: any) => {
  return {
    ...state,
    categoryToUpdateStatus: payload,
  };
};

export const setProductWithInfosUpdated = (
  state: IStatusListUpdate,
  payload: any,
) => {
  return {
    ...state,
    productUpdatedInfos: payload,
  };
};

export const setProductStockUpdated = (
  state: IStatusListUpdate,
  payload: any,
) => {
  return {
    ...state,
    productStockUpdated: payload,
  };
};
